module.exports = __webpack_public_path__ + "img/photo-14.535f6990.jpg";